import React from "react";
import { Link, useLocation } from 'react-router-dom'
import {
    UserImg,
    UserIcon,
    CalendarIcon,
    ChatIcon,
    LogoutIcon,
} from "../../../Constant/Index";
const UserSideBar = () => {
    const location = useLocation();
    const SideBarContent = [
        {
            Name: "My Profile",
            LinkTo: "/user/home",
            Icon: UserIcon
        },
        {
            Name: "My Appointments",
            LinkTo: "/user/appointments",
            Icon: CalendarIcon
        },
        {
            Name: "Chats",
            LinkTo: "/user/chat",
            Icon: ChatIcon
        },
        {
            Name: "Log Out",
            LinkTo: "/",
            Icon: LogoutIcon
        },
    ]
    return (
        <>
            <aside className="col-lg-3 col-md-4 pb-5 pb-lg-0">
                <div className="sidebar-here">
                    <div className="about-user-aside">
                        <figure className="usericon">
                            <img src={UserImg} className="img-here" alt="" />
                            <label htmlFor="UploadUserImage" className="upload-img">
                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15" r="13.75" fill="#FFF8E9" stroke="#01323B" stroke-width="1.5" />
                                    <path d="M20.5176 11.6803L14.8185 17.3794C14.251 17.947 12.5663 18.2098 12.1899 17.8335C11.8136 17.4571 12.0705 15.7724 12.638 15.2049L18.3431 9.49983C18.4838 9.34634 18.6541 9.22295 18.8438 9.13711C19.0335 9.05126 19.2387 9.00473 19.4468 9.00034C19.655 8.99596 19.8619 9.0338 20.0551 9.11159C20.2482 9.18937 20.4236 9.30551 20.5706 9.45294C20.7176 9.60038 20.8333 9.77607 20.9105 9.96943C20.9878 10.1628 21.0251 10.3698 21.0201 10.5779C21.0152 10.7861 20.968 10.9911 20.8817 11.1806C20.7953 11.37 20.6715 11.5401 20.5176 11.6803Z" stroke="#01323B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14.3765 10.2471H11.3896C10.7558 10.2471 10.1481 10.4988 9.69992 10.947C9.2518 11.3951 9 12.0029 9 12.6366V18.6106C9 19.2443 9.2518 19.8521 9.69992 20.3002C10.1481 20.7484 10.7558 21.0001 11.3896 21.0001H17.9609C19.2811 21.0001 19.7531 19.9248 19.7531 18.6106V15.6236" stroke="#01323B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </label>
                            <input type="file" name="" id="UploadUserImage" hidden />
                        </figure>
                        <div className="user-data">
                            <h6 className="xs-heading small">Alexander Volk</h6>
                            <span className="email">@alaxenderVolk</span>
                        </div>
                    </div>
                    <ul className="profile-tabs">
                        {
                            SideBarContent.map((SingleLink, index) => (
                                <li className={`single-tab ${location.pathname === SingleLink.LinkTo ? 'active' : ''}`} key={index}>
                                    <Link to={SingleLink.LinkTo}><img src={SingleLink.Icon} alt="" /> {SingleLink.Name}</Link>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </aside>
        </>
    )
}
export default UserSideBar;